import React, { useRef, useEffect, useState } from "react";
import { X, Save } from "lucide-react";
import Button from "../../../common/Button";
import "./FormFooter.css";

export default function FormFooter({
  onCancel,
  onSave,
  saveDisabled,
  cancelLabel = "Cancel",
  saveLabel = "Save",
}) {
  const sentinelRef = useRef(null);
  const [isStuck, setIsStuck] = useState(false);

  useEffect(() => {
    const sentinel = sentinelRef.current;
    if (!sentinel) return;
    const observer = new IntersectionObserver(
      ([entry]) => setIsStuck(!entry.isIntersecting),
      { threshold: 1.0 }
    );
    observer.observe(sentinel);
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <div className={`form-footer${isStuck ? " form-footer--stuck" : ""}`}>
        <div className="form-footer-actions">
          <Button className="button--cancel" onClick={onCancel}>
            <X size={16} style={{ marginRight: "6px" }} />
            {cancelLabel}
          </Button>
          <Button
            className="button--save"
            onClick={onSave}
            disabled={saveDisabled}
          >
            <Save size={16} style={{ marginRight: "6px" }} />
            {saveLabel}
          </Button>
        </div>
      </div>
      <div ref={sentinelRef} style={{ height: "1px" }} />
    </>
  );
}
